import * as React from "react";
import { useTheme } from "@mui/material/styles";
import { Box, Typography, Grid } from "@mui/material";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import "../../../../assets/styles/audio-question.css";
import Audio from "../../../ui-components/Audio";

export default function CorrectOrderMatch({ question, onAnswer = () => {} }) {
  const theme = useTheme();
  const [answer, setAnswer] = React.useState([]);
  const [initialItems, setInitialItems] = React.useState([]);

  React.useEffect(() => {
    if (question && question.questionList) {
      setAnswer(question.questionList.map(() => []));
      if (question.questionList[0] && question.questionList[0].choices) {
        setInitialItems(question.questionList[0].choices);
      } else {
        setInitialItems([]);
      }
    }
  }, [question]);

  const handleSetAnswer = (updatedAnswer) => {
    setAnswer(updatedAnswer);

    const answerValue = {};
    const keypair =
      question.questionList[0].keypair || question.questionList[0].keypairImage;

    keypair.forEach((key, index) => {
      const keyName = key.name || key;
      if (updatedAnswer[0] && updatedAnswer[0].length > index) {
        answerValue[keyName] = updatedAnswer[0][index].value;
      } else {
        answerValue[keyName] = "";
      }
    });

    onAnswer({
        canProceed: true,
        answer: answerValue,
    });
  };

  const onDragEnd = (result) => {
    if (!result.destination) return;

    const sourceIndex = result.source.index;
    const destinationIndex = result.destination.index;
    const sourceDroppableId = result.source.droppableId;
    const destinationDroppableId = result.destination.droppableId;

    let updatedAnswer = [...answer];
    let updatedInitialItems = [...initialItems];
    const keypair =
      question.questionList[0].keypair || question.questionList[0].keypairImage;
    const maxItems = keypair.length;

    if (
      sourceDroppableId === "droppable-initial" &&
      destinationDroppableId.startsWith("droppable-choices")
    ) {
      const i = parseInt(destinationDroppableId.split("-")[2], 10);
      if (updatedAnswer[i].length >= maxItems) return;

      const [movedItem] = updatedInitialItems.splice(sourceIndex, 1);
      updatedAnswer[i] = Array.from(updatedAnswer[i] || []);
      updatedAnswer[i].splice(destinationIndex, 0, movedItem);
    } else if (
      sourceDroppableId.startsWith("droppable-choices") &&
      destinationDroppableId === "droppable-initial"
    ) {
      const i = parseInt(sourceDroppableId.split("-")[2], 10);
      updatedAnswer[i] = Array.from(updatedAnswer[i] || []);
      const [movedItem] = updatedAnswer[i].splice(sourceIndex, 1);
      updatedInitialItems.splice(destinationIndex, 0, movedItem);
    } else if (sourceDroppableId === destinationDroppableId) {
      const i = parseInt(sourceDroppableId.split("-")[2], 10);
      const items = Array.from(updatedAnswer[i] || []);
      const [reorderedItem] = items.splice(sourceIndex, 1);
      items.splice(destinationIndex, 0, reorderedItem);
      updatedAnswer[i] = items;
    }

    setInitialItems(updatedInitialItems);
    handleSetAnswer(updatedAnswer);
  };

  return (
    <React.Fragment>
      <Box className="choices-container" sx={{ px: 4, textAlign: "center" }}>
        {question && question.questionImage && (
          <img
            src={question.questionImage}
            alt="Question Illustration"
            style={{ width: "100%", marginTop: "20px" }}
          />
        )}
       
        {question.questionAudio && (
            <Audio audioText={question.questionAudio} />
        )}
        <DragDropContext onDragEnd={onDragEnd}>
          <Grid container spacing={2} sx={{ mt: 2, justifyContent: "space-between" }}>
            <Grid item xs={6}>
              <Grid container direction="column">
                {question &&
                  question.questionList &&
                  question.questionList[0] &&
                  (question.questionList[0].keypair ||
                    question.questionList[0].keypairImage) &&
                  (
                    question.questionList[0].keypair ||
                    question.questionList[0].keypairImage
                  ).map((key, idx) => (
                    <Box
                      key={`keypair-${idx}`}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: theme.palette.primary.main,
                        fontWeight: "bold",
                        p: 1,
                        backgroundColor: "#f0f0f0",
                        height: key.image ? "113px" : "56px",
                        mb: 0,
                      }}
                    >
                      {key.image ? (
                        
                        <img
                          src={key.image}
                          alt={key.name}
                          style={{ height: "80px", marginRight: "10px" }}
                        />
                      ) : (
                        <Typography>{key}</Typography>
                      )}
                    </Box>
                  ))}
              </Grid>
            </Grid>
            <Grid item xs={6} className="HHS" sx={{ flexBasis: "40%", width: '40%!important'}}>
              <Droppable droppableId="droppable-choices-0">
                {(provided) => (
                  <div
                    {...provided.droppableProps}
                    ref={provided.innerRef}
                    style={{
                      height: "100%",
                      backgroundColor: "#f9f9f9",
                      paddingBottom: "0",
                      borderRadius: "4px",
                      border: "1px dashed #ccc",
                    }}
                  >
                    {answer[0] &&
                      answer[0].map((choice, index) => (
                        <Draggable
                          key={`choice-${index}`}
                          draggableId={`choice-${index}`}
                          index={index}
                        >
                          {(provided) => (
                            <div
                              ref={provided.innerRef}
                              {...provided.draggableProps}
                              {...provided.dragHandleProps}
                              className="audio-question-container"
                              style={{
                                userSelect: "none",
                                margin: "0 0 8px 0",
                                ...provided.draggableProps.style,
                              }}
                            >
                              <Typography
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  color: theme.palette.primary.main,
                                  fontWeight: "bold",
                                  p: 1,
                                  cursor: "pointer",
                                  border: "1px solid #ddd",
                                  borderRadius: "4px",
                                  width: "100%",
                                  justifyContent: "center",
                                  height: question.questionList[0].keypairImage
                                    ? "87px"
                                    : "56px",
                                }}
                              >
                                {choice.value}
                              </Typography>
                            </div>
                          )}
                        </Draggable>
                      ))}
                    {provided.placeholder}
                  </div>
                )}
              </Droppable>
            </Grid>
          </Grid>
          <Droppable droppableId="droppable-initial">
            {(provided) => (
              <div
                {...provided.droppableProps}
                ref={provided.innerRef}
                style={{
                  minHeight: "100px",
                  backgroundColor: "#f0f0f0",
                //   padding: "8px",
                  borderRadius: "4px",
                  border: "1px dashed #ccc",
                  marginBottom: "20px",
                  marginTop: "20px",
                }}
              >
                {initialItems &&
                  initialItems.map((choice, index) => (
                    <Draggable
                      key={`initial-${index}`}
                      draggableId={`initial-${index}`}
                      index={index}
                    >
                      {(provided) => (
                        <div
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                          className="audio-question-container"
                          style={{
                            userSelect: "none",
                            margin: "0 0 8px 0",
                            ...provided.draggableProps.style,
                          }}
                        >
                          <Typography
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              color: theme.palette.primary.main,
                              fontWeight: "bold",
                              p: 1,
                              cursor: "pointer",
                              border: "1px solid #ddd",
                              borderRadius: "4px",
                              width: "100%",
                              justifyContent: "center",
                              height: "56px",
                            }}
                          >
                            {choice.value}
                          </Typography>
                        </div>
                      )}
                    </Draggable>
                  ))}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </DragDropContext>
      </Box>
    </React.Fragment>
  );
}
